import autoComplete from "@tarekraafat/autocomplete.js/src/autoComplete";

export default class Autocomplete {
	constructor() {
		this.form = document.getElementById("gform_wrapper_5");
		this.search = document.querySelectorAll(".search-form input[name='input_1']");
		this.init();
	}

	init() {
		if (this.search) {
			this.search.forEach((search) => {
				const formData = new FormData();
				formData.append("action", "ac_post_titles");
				new autoComplete({
					selector: () => {
						return search;
					},
					wrapper: false,
					data: {
						src: async () => {
							try {
								formData.append("term", search.value);
								const source = await fetch(EHTScripts.url.ajax, {
									body: formData,
									credentials: "same-origin",
									headers: {
										Accept: "application/json",
									},
									method: "POST",
								});
								const response = await source.json();
								return response;
							} catch (error) {
								return error;
							}
						},
						keys: ["data", "value"],
					},
					resultsList: {
						tag: "div",
						id: "acSearchForm",
						class: "-mt-7 text-sm",
						destination: "#gform_wrapper_5",
						maxResults: 10,
					},
					resultItem: {
						tag: "div",
						class: "not-prose mb-1 bg-water",
						element: (item, data) => {
							item.innerHTML = `<a class="block px-4 py-2 hover:bg-blue hover:text-white " href="${data.value.data.link}">${data.match}</a>`;
						},
					},
					threshold: 3,
					submit: true,
				});
			});
		}
	}
}
